import Layout from '@/layout/index.vue';
export default [
  {
    // 品牌
    path: '/brandManag',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'addRole',
        component: () => import('@/views/brand/brandManag/addRole.vue'),
        name: 'AddRole',
        meta: { title: '新增角色', icon: 'role', noCache: true },
      },
      {
        path: 'storeDetail',
        component: () => import('@/views/brand/storeManag/storeDetail.vue'),
        name: 'StoreDetail',
        meta: { title: '门店经营信息', icon: 'role', noCache: true },
      },
      {
        path: '/onlineOperation/decorate/decorateAdd',
        component: () => import('@/views/onlineOperation/decorate/decorateAdd.vue'),
        name: 'DecorateAdd',
        meta: { title: '新增装修模板', icon: '', noCache: true },
      },
      {
        path: '/onlineOperation/advert/advertEdit',
        component: () => import('@/views/onlineOperation/advert/advertEdit.vue'),
        name: 'AdvertEdit',
        meta: { title: '广告设置', icon: '', noCache: true, activeMenu: '/onlineOperation/advert' },
      },
      {
        path: '/onlineOperation/channelManage/miniProgramManage',
        component: () => import('@/views/brand/integration/miniProgramManage.vue'),
        name: 'MiniProgramManage',
        meta: { title: '管理小程序', icon: '', noCache: true, activeMenu: '/onlineOperation/channelManage' },
      },
    ],
  },
];
